import { MemberResponse } from 'services/api/member/types';

export const mockMemberDataResponse: MemberResponse = {
  member: {
    fantasyName: 'mark',
    organizationName: 'Allan Alvarenga LTDA',
    status: 'ACTIVE',
    CNPJ: '48278835000134',
    mainActivity: '62',
    firstName: 'ALLAN MAURÍCIO',
    lastName: 'SANCHES BAPTISTA DE ALVARENGA',
    occupation: 'Management',
    socialReason: 'Allan Alvarenga LTDA',
    numberOfEmployees: 'Até 19',
    annualBudgetforTravel: 'R$ 5 mil a R$ 25 mil',
    tier: 'VoeBiz',
    milesBalance: '4100000',
    milesToExpire: '7500',
    milesNextExpirationDate: '11/30/2024 10:48:41',
    address: {
      streetAddress: 'Lisandro Camp',
      streetAddressNumber: '405',
      complement: '',
      zipCode: '02050020',
      city: 'SÃO PAULO',
      state: 'SP',
      country: 'Brazil',
    },
    DocumentType: 'CPF',
    DOcumentNumber: '38933796819',
    celPhoneDDINumber1: '55',
    celPhoneDDDNumber1: '11',
    celPhoneNumber1: '988270933',
    celPhoneDDINumber2: '',
    celPhoneDDDNumber2: '',
    celPhoneNumber2: '',
    workPhoneDDINumber: '',
    workPhoneDDDNumber: '',
    workPhoneNumber: '',
    homePhoneDDINumber1: '55',
    homePhoneDDDNumber1: '0',
    homePhoneNumber1: '',
    email: 'allan.baptista@gmail.com',
    HowYouMettheProgram: 'Outros',
    memberNumberVoeBiz: '',
  },
};

const mockEssencialMemberDataResponse = {
  ...mockMemberDataResponse,
  member: {
    ...mockMemberDataResponse.member,
    tier: 'Essencial',
  },
};

const mockPrimeMemberDataResponse = {
  ...mockMemberDataResponse,
  member: { ...mockMemberDataResponse.member, tier: 'Prime' },
};

const mockSuperPrimeMemberDataResponse = {
  ...mockMemberDataResponse,
  member: { ...mockMemberDataResponse.member, tier: 'Super Prime' },
};

const mockExclusiveMemberDataResponse = {
  ...mockMemberDataResponse,
  member: {
    ...mockMemberDataResponse.member,
    tier: 'exclusive',
  },
};

export const memberMocks = {
  voebiz: mockMemberDataResponse.member,
  essencial: mockEssencialMemberDataResponse.member,
  prime: mockPrimeMemberDataResponse.member,
  superPrime: mockSuperPrimeMemberDataResponse.member,
  exclusive: mockExclusiveMemberDataResponse.member,
};
